// faqs page

// $(document).ready(function($) {
//     $('.block__title_tab').click(function() {
//         $(this).parent().find('.block__inner_content').slideToggle();
//         $(this).parent().siblings().find('.block__inner_content').slideUp();
//         $(this).parent().toggleClass('active');
//         $(this).parent().siblings().removeClass('active');
//     });
// });

// $(document).ready(function() {
//     $(".block__mobile-menu-click").click(function() {
//         $(".block__mobile-menu-click").toggleClass("main");
//     });
// });


var accItem = document.getElementsByClassName('accordionItem');
var accHD = document.getElementsByClassName('accordionItemHeading');
for (i = 0; i < accHD.length; i++) {
    accHD[i].addEventListener('click', toggleItem, false);
}

function toggleItem() {
    var itemClass = this.parentNode.className;
    for (i = 0; i < accItem.length; i++) {
        accItem[i].className = 'accordionItem close';
    }
    if (itemClass == 'accordionItem close') {
        this.parentNode.className = 'accordionItem open';
    }
}